(() => {
  'use-strict';

  // code ge from: https://codepen.io/Ricozor/pen/zYJdQBN

  let fadeInit = false;
  const main = document.querySelector('.js-blade-sections');
  const sections = document.querySelectorAll('.js-blade-section');
  let viewportHeight = 0;
  let viewportThreshold = 0;
  const minHeightVisible = 0;

  const resize = () => {
    // Change 33% earlier than scroll position so color is there when you arrive.
    viewportHeight = window.innerHeight;
    viewportThreshold = viewportHeight / 2;
  };

  const fadeIn = () => {
    sections.forEach((section, index) => {
      const sectionTop = section.getBoundingClientRect().top;
      const sectionBottom = section.getBoundingClientRect().bottom;
      let sectionId;
      if (index === 0) {
        sectionId = 'first';
      } else if (index === sections.length - 1) {
        sectionId = 'last';
      } else {
        sectionId = index + 1;
      }
      const sectionTopOverBottomViewport = viewportHeight - viewportThreshold - minHeightVisible;
      const topOverBottomViewport = sectionTop <= sectionTopOverBottomViewport;
      const bottomUnderTopViewport = sectionBottom >= sectionTopOverBottomViewport;
      const isInView = (sectionId === 'first' || topOverBottomViewport) && (sectionId === 'last' || bottomUnderTopViewport);
      let wasInView = section.getAttribute('data-was-in-view');

      if (!fadeInit && isInView) {
        wasInView = true;
      } else if (wasInView !== null) {
        wasInView = wasInView === 'true'; // if existe set boolean value, else keep null
      }

      if (isInView === true && wasInView === false) {
        main.setAttribute('data-theme', section.getAttribute('data-theme-blade'));
        main.setAttribute('data-section', sectionId);
        if (index > 0) {
          main.classList.add('isAnimated');
        }
      }

      /* if (isInView === true) {
        console.log('section', `Section ${index}`);
      }

      if (wasInView === true && isInView === false) {
        console.log('<<<< leave viewport <<<<', `Section ${index}`);
      } */

      section.setAttribute('data-was-in-view', isInView);
    });

    fadeInit = true;
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
      fadeIn();
    });
  });

  window.addEventListener('resize', () => {
    window.requestAnimationFrame(() => {
      resize();
      fadeIn();
    });
  });

  resize();
  fadeIn();
})();
